/*
 * Couleur お気に入り（Wishlist / 旧カラーミー お気に入り 相当）
 * Shopify 標準機能外 → localStorage ベース（閲覧履歴と同設計・ゲストOK／ログイン不要）。
 * - トグル: [data-wishlist-toggle] を委譲クリックで追加/削除。
 *           商品カードの .fav-btn はリンク内に置くため preventDefault でナビゲーションを抑止。
 *           PDP は data-rv-source を付け #pdp-rv-data(JSON) を商品データ源にする。
 * - 描画: [data-wishlist] コンテナに保存カードを生成（専用ページ）。空なら .wl-empty を表示しグリッドを隠す。
 * - 件数: [data-wishlist-count] を全インスタンス更新（ヘッダー desktop＋モバイル複製）。
 * カード体裁は couleur-home.css の .pgrid/.pcell/.pimg/.pmeta を流用。
 */
(function () {
  'use strict';
  var KEY = 'couleur-wishlist';
  var MAX = 100;
  var HEART =
    '<svg class="fav-ico" viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false">' +
    '<path d="M12 20.3l-1.45-1.32C5.4 14.25 2 11.18 2 7.4 2 4.42 4.34 2.1 7.3 2.1c1.67 0 3.28.78 4.35 2.01h.7C13.42 2.88 15.03 2.1 16.7 2.1 19.66 2.1 22 4.42 22 7.4c0 3.78-3.4 6.85-8.55 11.59L12 20.3z" ' +
    'fill="none" stroke="currentColor" stroke-width="1.3"/></svg>';

  function read() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function write(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} }
  function esc(s) { var d = document.createElement('div'); d.textContent = (s == null ? '' : String(s)); return d.innerHTML; }
  function has(h) { return read().some(function (x) { return x.handle === h; }); }

  // data-* から商品オブジェクトを取得（PDP は #pdp-rv-data 優先）
  function dataFrom(el) {
    var d = el.dataset || {};
    // data-rv-source は値なし属性のため hasAttribute で判定（dataset.rvSource==="" は falsy）
    if (el.hasAttribute && el.hasAttribute('data-rv-source')) {
      var node = document.getElementById('pdp-rv-data');
      if (node) { try { return JSON.parse(node.textContent); } catch (e) {} }
    }
    if (!d.handle) return null;
    return {
      handle: d.handle, title: d.title, vendor: d.vendor, url: d.url,
      img: d.img || '', price: d.price || '', inquiry: d.inquiry === 'true'
    };
  }

  function toggle(p) {
    if (!p || !p.handle) return false;
    var a = read(), i = -1;
    for (var k = 0; k < a.length; k++) { if (a[k].handle === p.handle) { i = k; break; } }
    var added;
    if (i >= 0) { a.splice(i, 1); added = false; }
    else { a.unshift(p); if (a.length > MAX) a = a.slice(0, MAX); added = true; }
    write(a);
    return added;
  }
  function remove(h) { write(read().filter(function (x) { return x.handle !== h; })); }

  // 専用ページ用カード（削除ボタンは本物の <button>、リンクは stretched-link で全面クリック可）
  function card(p) {
    var price = p.inquiry ? ((window.CouleurI18n && window.CouleurI18n.inquiry_price_html) || 'Inquiry &rarr;') : esc(p.price);
    return '<div class="pcell wl-cell">' +
      '<button class="fav-btn is-faved" type="button" aria-label="' + ((window.CouleurI18n && window.CouleurI18n.wishlist_remove) || 'お気に入りから外す') + '" data-wishlist-remove="' + esc(p.handle) + '">' + HEART + '</button>' +
      '<a class="pcell-link" href="' + esc(p.url) + '">' +
        '<div class="pimg">' + (p.img ? '<img loading="lazy" src="' + esc(p.img) + '" alt="">' : '') + '</div>' +
        '<div class="pmeta">' +
          '<span class="pbrand">' + esc(p.vendor) + '</span>' +
          '<span class="pname">' + esc(p.title) + '</span>' +
          '<span class="pprice">' + price + '</span>' +
        '</div>' +
      '</a></div>';
  }

  function renderLists() {
    var items = read();
    var lists = document.querySelectorAll('[data-wishlist]');
    for (var i = 0; i < lists.length; i++) {
      var el = lists[i];
      var section = el.closest ? el.closest('[data-wl-section]') : null;
      var empty = section ? section.querySelector('.wl-empty') : null;
      if (!items.length) {
        el.innerHTML = '';
        el.hidden = true;
        if (empty) empty.hidden = false;
      } else {
        el.innerHTML = items.map(card).join('');
        el.hidden = false;
        if (empty) empty.hidden = true;
      }
    }
  }

  function syncToggles() {
    var n = read().length;
    var counts = document.querySelectorAll('[data-wishlist-count]');
    for (var i = 0; i < counts.length; i++) counts[i].textContent = n;
    var toggles = document.querySelectorAll('[data-wishlist-toggle]');
    for (var j = 0; j < toggles.length; j++) {
      var t = toggles[j], p = dataFrom(t), on = !!(p && has(p.handle));
      t.classList.toggle('is-faved', on);
      if (t.hasAttribute('aria-pressed')) t.setAttribute('aria-pressed', on ? 'true' : 'false');
      var lab = t.querySelector('.fav-label');
      if (lab) {
        var on_t = t.getAttribute('data-label-on'), off_t = t.getAttribute('data-label-off');
        if (on_t && off_t) lab.textContent = on ? on_t : off_t;
      }
    }
  }

  function onClick(e) {
    if (!e.target.closest) return;
    var rm = e.target.closest('[data-wishlist-remove]');
    if (rm) {
      e.preventDefault(); e.stopPropagation();
      remove(rm.getAttribute('data-wishlist-remove'));
      renderLists(); syncToggles();
      return;
    }
    var tg = e.target.closest('[data-wishlist-toggle]');
    if (tg) {
      e.preventDefault(); e.stopPropagation();
      var p = dataFrom(tg);
      if (p) { toggle(p); syncToggles(); renderLists(); }
    }
  }

  function init() {
    document.addEventListener('click', onClick);
    renderLists();
    syncToggles();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
